import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import type { Brand } from '@/data/brands.api';
import type { Category } from '@/data/categories.api';

type UbuyMegaMenuProps = {
  language: 'mn' | 'en';
  categories: Category[];
  brands: Brand[];
};

export default function UbuyMegaMenu({ language, categories, brands }: UbuyMegaMenuProps) {
  const categoryItems = categories.slice(0, 10);
  const brandItems = brands.slice(0, 10);

  return (
    <div className="absolute left-1/2 top-full z-50 hidden w-[min(980px,calc(100vw-48px))] -translate-x-1/2 pt-3 group-hover:block">
      <div className="grid gap-8 rounded-b-[15px] border border-[var(--ubuy-border-soft)] bg-white p-6 shadow-[0_18px_45px_rgba(0,0,0,0.14)] lg:grid-cols-[1.1fr_1fr_0.9fr]">
        <div>
          <p className="mb-3 text-[13px] font-bold text-[var(--ubuy-title)]">
            {language === 'mn' ? 'Ангиллууд' : 'Popular categories'}
          </p>
          <div className="grid grid-cols-2 gap-2">
            {categoryItems.map((category) => (
              <Link
                key={category.id}
                to={`/products?category=${category.slug}`}
                className="rounded-lg border border-transparent px-3 py-2 text-sm text-[var(--ubuy-muted)] hover:border-[var(--ubuy-border-soft)] hover:bg-[var(--ubuy-subtle-surface)] hover:text-[var(--ubuy-title)]"
              >
                {category.name}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="mb-3 text-[13px] font-bold text-[var(--ubuy-title)]">
            {language === 'mn' ? 'Brand сонголтууд' : 'Featured brands'}
          </p>
          <div className="grid grid-cols-2 gap-2">
            {brandItems.map((brand) => (
              <Link
                key={brand.id}
                to={`/products?brand=${brand.slug}`}
                className="rounded-lg border border-transparent px-3 py-2 text-sm text-[var(--ubuy-muted)] hover:border-[var(--ubuy-border-soft)] hover:bg-[var(--ubuy-subtle-surface)] hover:text-[var(--ubuy-title)]"
              >
                {brand.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="rounded-[12px] bg-[var(--ubuy-subtle-surface)] p-4">
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-[var(--ubuy-muted)]">
            KG Goods
          </p>
          <h3 className="mt-2 text-lg font-bold leading-6 text-[var(--ubuy-title)]">
            {language === 'mn' ? 'Аюулгүй, найдвартай төлбөр' : 'Secure local checkout'}
          </h3>
          <p className="mt-2 text-sm leading-6 text-[var(--ubuy-muted)]">
            {language === 'mn'
              ? 'QPay болон банкны апп-аар төлж, ойрын cargo салбараас авах боломжтой.'
              : 'Pay with QPay or your bank app, then pick up from the nearest cargo branch.'}
          </p>
          <Link
            to="/cargo-branches"
            className="mt-4 inline-flex items-center gap-2 rounded-lg bg-[var(--ubuy-accent)] px-4 py-2 text-sm font-bold text-[var(--ubuy-title)]"
          >
            {language === 'mn' ? 'Салбар харах' : 'View branches'}
            <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </div>
  );
}
